import { inject, Injectable, signal } from '@angular/core';
import { ThemeService } from './shared/utils/services/theme.service';
import { InstallService } from './shared/utils/services/install.service';
import { UserService } from './shared/services/user.service';
import { Router } from '@angular/router';
import { BusinessService } from './shared/services/business.service';
import { LanguageService } from './shared/utils/services/language.service';
import { DeviceService } from './shared/services/device.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private deviceService = inject(DeviceService);
  private themeService = inject(ThemeService);
  private installService = inject(InstallService);
  private userService = inject(UserService);
  private businessService = inject(BusinessService);
  private router = inject(Router);
  private languageService = inject(LanguageService);

  loading = signal<boolean>(true);

  constructor() {}

  async init() {
    // Theme Initialization
    this.themeService.init();

    // Install Service
    this.installService.start();

    // User Service
    const user = await this.userService.init();
    // console.log(user);
    if (user && user?.has_business) {
      await this.businessService.init();
      // this.router.navigateByUrl('/home');
      // this.loading.set(false);
    } else if (user === null) {
      this.loading.set(false);
    } else if (user && !user?.has_business) {
      this.router.navigateByUrl('/onboarding');
      this.loading.set(false);
    }

    // Initialize Languages
    await this.languageService.init();

    // Device Initialization
    this.deviceService.init();

    this.loading.set(false);
  }

  installApp() {
    this.installService.installApp();
  }
}
